// Push notifications admin API (apbe /api/push). Kept in its own module so the
// push feature doesn't touch the shared services/api.js.
import api from './api';

export const pushAPI = {
  meta: () => api.get('/push/meta'),
  list: (params) => api.get('/push/campaigns', { params }),
  get: (id) => api.get(`/push/campaigns/${id}`),
  create: (body) => api.post('/push/campaigns', body),
  update: (id, body) => api.put(`/push/campaigns/${id}`, body),
  remove: (id) => api.delete(`/push/campaigns/${id}`),
  duplicate: (id) => api.post(`/push/campaigns/${id}/duplicate`),
  approval: (id) => api.get(`/push/campaigns/${id}/approval`),
  approve: (id, body) => api.post(`/push/campaigns/${id}/approve`, body || {}),
  pause: (id) => api.post(`/push/campaigns/${id}/pause`),
  resume: (id, body) => api.post(`/push/campaigns/${id}/resume`, body || {}),
  cancel: (id) => api.post(`/push/campaigns/${id}/cancel`),
  testCampaign: (id, body) => api.post(`/push/campaigns/${id}/test`, body),
  testDraft: (body) => api.post('/push/test', body),
  audienceCount: (body) => api.post('/push/audience-count', body),
  uploadImage: (body) => api.post('/push/upload-image', body),
  report: (id) => api.get(`/push/campaigns/${id}/report`),
  audit: (params) => api.get('/push/audit', { params }),
  deviceStats: () => api.get('/push/devices/stats'),
};

export const errMsg = (e, fallback = 'Something went wrong') =>
  e?.response?.data?.message || e?.message || fallback;
